
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/digital-tools/ship-schedules",
      function () {
        return require("private-next-pages/digital-tools/ship-schedules/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/digital-tools/ship-schedules"])
      });
    }
  